export default {
    namespaced: true,
    state: {
        obj: {},
        objs: []
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload;
        },
        setObj(state, pload) {
            state.obj = pload;
        }
    },
    actions: {
        getData({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}pembagian-koordinator-lk?size=${payload.size}&date=${payload.date}&coordinator=${payload.coordinator}`;
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            });
        },
        store({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "pembagian-koordinator-lk";
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            });
        }
    }
}